import React from 'react';
import { Button } from '@unmind/design-system';
import {
  EmptyActionContainer,
  EmptyContainer,
  EmptySubtitle,
  EmptyTitle,
  EmptyTitleContainer,
  MagIcon,
} from './styles';

type EmptyStateCardProps = {
  title: string;
  subtitle: string;
  action?: {
    label: string;
    onClick(): void;
  };
};

const EmptyStateCard = ({ title, subtitle, action }: EmptyStateCardProps) => (
  <EmptyContainer>
    <EmptyTitleContainer>
      <MagIcon aria-hidden />
      <EmptyTitle>{title}</EmptyTitle>
    </EmptyTitleContainer>
    <EmptySubtitle>{subtitle}</EmptySubtitle>
    {action && (
      <EmptyActionContainer>
        <Button variant="secondary" onClick={action.onClick}>
          {action.label}
        </Button>
      </EmptyActionContainer>
    )}
  </EmptyContainer>
);

export default EmptyStateCard;
